import type { InitOverrideFunction, RequestOpts } from '../generated-types/runtime'
import { Configuration, ResponseError } from '../generated-types/runtime'
import { V1Api } from '../generated-types/apis/V1Api'
import LogTool from '../logger/logTools'
import { getAccessToken, getApiBasePath, refreshAccessToken } from './authTokens'

const log = new LogTool({ context: 'V1ApiClient', enable: true, logLevel: 'warn' })

class AuthenticatedV1Api extends V1Api {
  constructor() {
    super(
      new Configuration({
        basePath: getApiBasePath(),
      })
    )
  }

  private withAuthorization(context: RequestOpts, token?: string): RequestOpts {
    if (!token) {
      return context
    }

    return {
      ...context,
      headers: {
        ...context.headers,
        Authorization: `Bearer ${token}`,
      },
    }
  }

  protected override async request(
    context: RequestOpts,
    initOverrides?: RequestInit | InitOverrideFunction
  ): Promise<Response> {
    const token = await getAccessToken()
    const contextWithToken = this.withAuthorization(context, token)

    try {
      return await super.request(contextWithToken, initOverrides)
    } catch (error) {
      if (error instanceof ResponseError && error.response.status === 401) {
        log.info('Received 401 from V1 API, attempting token refresh')

        const refreshedToken = await refreshAccessToken()
        if (!refreshedToken) {
          log.warn('Token refresh failed for V1 API request')
          throw error
        }

        const retriedContext = this.withAuthorization(context, refreshedToken)
        return super.request(retriedContext, initOverrides)
      }

      throw error
    }
  }
}

export const v1Api = new AuthenticatedV1Api()

